import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { jsonGet } from '../api';
import { AuthorizedEmail } from '../models/authorizedEmails';

type SliceModel = AuthorizedEmail;
const sliceName: string = 'authorizedEmails';

const currRequests: Set<ModelId> = new Set;

export const fetchAuthorizedEmail = createAsyncThunk(
    sliceName + '/fetchById',
    async (id: ModelId) => {
        if (currRequests.has(id)) {
            return null;
        } else {
            currRequests.add(id);
            return await jsonGet<SliceModel>('/data/' + sliceName + '/' + id);
        }
    }
);

export const authorizedEmailAdapter = createEntityAdapter<SliceModel>({
    selectId: (attrs: SliceModel) => attrs.id
});
export const authorizedEmailSlice = createSlice({
    name: sliceName,
    initialState: authorizedEmailAdapter.getInitialState(),
    reducers: {
        addMany: authorizedEmailAdapter.addMany,
        addOne: authorizedEmailAdapter.addOne,
        updateMany: authorizedEmailAdapter.updateMany,
        updateOne: authorizedEmailAdapter.updateOne,
        upsertOne: authorizedEmailAdapter.upsertOne,
        upsertMany: authorizedEmailAdapter.upsertMany,
        removeOne: authorizedEmailAdapter.removeOne
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder.addCase(fetchAuthorizedEmail.fulfilled, (state, action) => {
            if (action.payload) {
                currRequests.delete(action.payload.id);
                authorizedEmailAdapter.upsertOne(state, action.payload);
            }
        });
    },
});
